export default "__VITE_ASSET__BKQPjRIC__"